<script type="text/javascript">

    import { http } from '../../http';
    import Switchery from '../global/form/Switchery.vue';
    import TextareaAutosize from '../global/form/TextareaAutosize.vue';
    import SecureMessageList from './SecureMessageList';
    import Apps from '../../../core/Apps';
    import moment from 'moment';
    import { phoneNumber } from 'App/helpers';
    import SecureAuthenticationGate from 'Components/global/SecureAuthenticationGate.vue';
    var swal = require('sweetalert');

    export default {
        data() {
            return {
                messageText: '',
                sendingNote: false,
                fileMessages: [],
                messages: [],
                client: this.initial_client,
                attachment_mode: '',
                loading: false,
                attachments_loading: false,
                invoice: null,
                invoices: [],
                creditnote: null,
                creditnotes: [],
                journals: [],
                journal_files: [],
                journal: null,
                journal_file: null,
                attachedFiles: [0],
                journalEntryPrintLayout: '',
            }
        },

        props: {
            is_subscribed: {
                required: true
            },
            initial_client: {
                required: true
            },
            messaging_settings: {
                required: true
            },
            textAreaMaxHeight: {
                default: 'none'
            }
        },

        mounted() {
            this.resetForm();

            $(document).ready(function(){
                $(document).on('click', '.notifications-drop .dropdown-menu', function (e) {
                    e.stopPropagation();
                });
            });

            //Listen to client updated event
            this.$event_bus.$on('clientUpdated', (client) => {
                this.client = client;
            });

            this.$event_bus.$on('showSendSecureMessageInvoiceModal', (note) => {
                $('#send-secure-message-invoice-modal').on('shown.bs.modal', function (e) {
                    $("#messageInputField").focus();
                });

                $('#send-secure-message-invoice-modal').modal('show');
                this.$event_bus.$emit('load-secure-messages');
                this.sendingNote = true;

                if (note.type == 'invoice') {
                    this.selectInvoice(note);
                }

                if (note.type == 'creditnote') {
                    this.selectCreditnote(note);
                }
            });
        },

        methods: {
            phoneNumber,

            getFileArrayValidationError(index) {
                if (this.errors.collect()["file."+index]) {
                    return this.errors.first("file."+index);
                }

                return false;
            },

            openUploadPrompt() {
                $("#messagesFileUpload-" + this.attachedFiles[ this.attachedFiles.length - 1]).trigger('click');
            },

            formatAmount(amount) {
                return format_amount(amount, 2);
            },

            fetchAttachmentModels() {
                this.attachments_loading = true;

                http.get('/app/client/' + this.client.id + "/messaging/possible-attachments")
                    .then(({data}) => {
                        this.attachments_loading = false;
                        this.invoices = data.invoices;
                        this.creditnotes = data.creditnotes;
                        this.journal_files = data.journal_files;
                        this.journals = data.journal_entries;

                    })
                    .catch(({ error, errorBag }) => {
                        this.attachments_loading = false;
                    });
            },

            attachTo(type) {
                this.attachment_mode = type;
                $("#attachment-modal").modal("show");
            },

            resetAttachment(index) {
                this.fileMessages.splice(index,1);
                $('#messagesFileUpload-'+index).val('');
                this.attachedFiles.splice(index, 1);
                this.errors.clear();
            },

            resetAttachments() {
                this.errors.clear();
                this.fileMessages = [];
                this.attachedFiles = [0];
                this.invoice = null;
                this.creditnote = null;
                this.journal = null;
                this.journal_file = null;
                this.journalEntryPrintLayout = '';
                $('#messagesFileUpload-0').val('');
            },

            resetForm() {
                this.errors.clear();
                this.messageText = '';
                this.invoice = null;
                this.creditnote = null;
                this.journal = null;
                this.journal_file = null;
                $('#messagesFileUpload-0').val('');
                this.fileMessages = [];
                this.attachedFiles = [0];
            },

            sendMessagePrompt() {
                if (this.isMessageSizeAboveLimit) {
                    return;
                }

                if (!this.client.messaging_sms && !this.client.messaging_email) {
                    swal({
                        title: trans('client.popup_info_title'),
                        text: trans('client.popup_info_text'),
                        type: "warning",
                        showCancelButton: true,
                        cancelButtonText: trans('global.cancel'),
                    }, (confirmed) => {
                        if (confirmed) {
                            this.sendMessage();
                        }
                    });
                } else {
                    this.sendMessage();
                }
            },

            sendMessage() {
                let formData = new FormData(document.getElementById('send-message-form'));
                formData.append('is_from_user', 1);
                formData.append('client_id', this.client.id);

                if (this.invoice) {
                    formData.append('invoice_id', this.invoice.id);
                }

                if (this.creditnote) {
                    formData.append('creditnote_id', this.creditnote.id);
                }

                if (this.journal) {
                    formData.append('journal_id', this.journal.id);
                    if (this.journalEntryPrintLayout) {
                        formData.append('print_landscape', this.journalEntryPrintLayout);
                    }
                }

                if (this.journal_file) {
                    formData.append('journal_file_id', this.journal_file.id);
                }

                this.loading = true;

                http.post('/app/client/'+this.client.id+'/messaging/send', formData)
                    .then(({ data }) => {
                        this.resetForm();
                        this.errors.clear();
                        this.loading = false;
                        this.$event_bus.$emit('load-secure-messages', this.client.id);
                        this.$event_bus.$emit('load-messages-overview-conversations');
                    })
                    .catch(({ error, errorBag }) => {
                        this.loading = false;
                        this.$setErrorBag(errorBag);
                    });
            },

            updateNotifications() {
                var data = {
                    messaging_sms: this.client.messaging_sms,
                    messaging_email: this.client.messaging_email
                }

                http.post('/app/client/' + this.client.id + '/messaging/updateMessagingNotifications', data)
                    .then(({ data }) => {
                        this.errors.clear();
                        this.$forceUpdate();
                    })
                    .catch(({ error, errorBag }) => {
                        this.$setErrorBag(errorBag);
                    });
            },

            attachFile() {
                this.errors.clear();

                if (this.invoice || this.creditnote || this.journal || this.journal_file) {
                    this.fileMessages = [];
                }

                this.invoice = null;
                this.creditnote = null;
                this.journal = null;
                this.journal_file = null;
                this.fileMessages.push(
                    Array.from(document.getElementById('messagesFileUpload-' + this.attachedFiles[ this.attachedFiles.length - 1 ]).files)
                        .map(file => `${file.name} (${this.$filters.file_size(file.size)})`)
                        .join(', ')
                );
                this.attachedFiles.push(this.attachedFiles.length);
            },

            getDateFormatted(date) {
                return moment(date).locale(moment_locale).format('LL');
            },

            getJournalDateFormatted(date) {
                return moment(date, 'DD-MM-YYYY').locale(moment_locale).format('LL');
            },

            selectInvoice(invoice) {
                this.resetAttachments();
                this.fileMessages = [trans('global.invoice') + " " + invoice.number];
                this.invoice = invoice;
                $("#attachment-modal").modal("hide");
            },

            selectCreditnote(creditnote) {
                this.resetAttachments();
                this.fileMessages = [trans('global.creditnote') + ' ' + creditnote.number];
                this.creditnote = creditnote;
                $("#attachment-modal").modal("hide");
            },

            selectJournal(journal, printMode='') {
                this.resetAttachments();
                this.fileMessages = [trans('global.journal') + " " + this.getJournalDateFormatted(journal.date)];
                this.journal = journal;
                this.journalEntryPrintLayout = printMode;
                $("#attachment-modal").modal("hide");
            },

            selectJournalFile(journal_file) {
                this.resetAttachments();
                this.fileMessages = [journal_file.display_name];
                this.journal_file = journal_file;
                $("#attachment-modal").modal("hide");
            },
        },

        computed: {
            user() {
                return this.$store.state.auth.user;
            },

            is_dinero_connected() {
                return this.$store.getters['apps/isAppEnabled'](Apps.Dinero);
            },

            is_economic_connected() {
                return this.$store.getters['apps/isAppEnabled'](Apps.Economic);
            },

            is_journal_active() {
                return this.$store.getters['apps/isAppEnabled'](Apps.Journal);
            },

            can_edit_client() {
                return this.$can('edit-client', this.client);
            },

            can_see_invoices() {
                return this.$canEither('see-invoices', 'see-invoicesassigned');
            },

            attachedFileObjects() {
                const files = [];

                for (const index of this.attachedFiles) {
                    const element = document.getElementById(`messagesFileUpload-${index}`) || {};
                    files.push(...(element.files || []));
                }

                return files;
            },

            attachedFileSize() {
                return this.attachedFileObjects.reduce((sum, file) => sum + file.size, 0);
            },

            isMessageSizeAboveLimit() {
                const limit = 10 * 1024 * 1024; // 10 MB

                return (this.attachedFileSize + this.messageText.length) > limit;
            },

            deletion_days() {
                return Config.get('app.SECURE_MESSAGES_DELETION_DAYS');
            },
        },

        watch: {
            'client.messaging_email': function (val) {
                this.updateNotifications();
            },
            'client.messaging_sms': function (val) {
                this.updateNotifications();
            },
        },

        components: {
            SecureAuthenticationGate,
            Switchery,
            TextareaAutosize,
            SecureMessageList,
        },
    }
</script>

<template>
    <secure-authentication-gate :app-name="trans('settings.messaging_app_name')">
        <div class="client-messages-div flex-1 overflow-y-auto overflow-x-hidden h-full">
            <div class="row" v-if="messaging_settings.is_deletion_active">
                <div class="col">
                    <ep-banner variant="warning">
                        {{ trans('messaging.automatic_deletion_alert', {days: this.deletion_days}) }}
                    </ep-banner>
                </div>
            </div>
            <div class="client-messages row flex flex-col h-full">
                <div class="col-sm-12 flex-1">
                    <secure-message-list :client="client" />
                </div>

                <div class="col-xs-12">
                    <div class="attached-file m-t-10" v-for="(fileMessage, index) in fileMessages">
                        <div>
                            <span class="text-muted m-b-5"><i class="zmdi zmdi-attachment-alt m-r-5"></i> </span>
                            <span>{{ fileMessage }}</span>
                            <span class="text-muted">{{ trans('client.will_be_attached') }}</span>
                            <span v-show="getFileArrayValidationError(index)" class="text-danger m-l-5">{{ getFileArrayValidationError(index) }}</span>
                        </div>
                        <div class="flex align-center">
                        <span v-if="journal && journalEntryPrintLayout" class="capitalize text-sm bg-primary text-white px-3 py-2 rounded mr-5 nowrap">
                            <i class="fa fa-print"></i> {{ journalEntryPrintLayout }}
                        </span>
                            <a href="" @click.prevent="resetAttachment(index)">
                                <i class="zmdi zmdi-delete m-r-5"></i>
                            </a>
                        </div>
                    </div>
                    <span v-show="errors.has('file')" class="text-danger block m-l-5">{{ errors.first('file') }}</span>
                    <span v-show="isMessageSizeAboveLimit" class="text-danger block m-l-5 m-t-5">{{ trans('messaging.message_size_limit') }}</span>
                </div>

                <div  v-if="can_edit_client" class="col-sm-12 col-xs-12">
                    <form id="send-message-form" class="client-messages-form pt-3"  @submit.prevent="sendMessagePrompt">
                        <div class="input-group m-l-5 " :class="{ 'has-error' : errors.has('text') || errors.has('file') }">

                            <div class="btn-group notifications-drop m-r-10 dropup">
                                <a href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :class="{ 'btn-danger' : !client.messaging_email && !client.messaging_sms } " class="btn btn-trans btn-custom dropdown-toggle" style="height: 36px;">
                                <span>
                                    <i class="zmdi zmdi-notifications-active" v-if="client.messaging_email || client.messaging_sms"></i>
                                    <i class="zmdi zmdi-notifications-off" v-else></i>
                                </span>
                                </a>
                                <div role="menu" class="dropdown-menu p-0" style="width:350px;">
                                    <ul class="list-group m-b-0">
                                        <li class="list-group-item">
                                            <div v-if="client.email">
                                                <switchery :text="trans('client.notify_via_email')" class="m-b-0" name="email_notify" v-model="client.messaging_email" v-if="client.email"></switchery>
                                            </div>
                                            <div class="text-muted" v-else>
                                                {{ trans('client.add_email') }}
                                            </div>
                                        </li>
                                        <li class="list-group-item">

                                            <div v-if="client.phone">
                                                <switchery :text="trans('client.notify_via_phone', { price : phoneNumber(client.phone, user).priceFormatted() } )" class="m-b-0"  name="sms-notify" v-model="client.messaging_sms"  v-if="client.phone" :editable="is_subscribed"></switchery>
                                                <small class="text-muted" v-if="!is_subscribed">{{ trans('client.sms_notifications') }}</small>
                                            </div>

                                            <div class="text-muted" v-else>
                                                {{ trans('client.add_phone') }}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="btn-group attachment-drop m-r-10 dropup" v-if="!sendingNote">
                                <a @click="fetchAttachmentModels" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-trans btn-custom dropdown-toggle" style="height: 36px;">
                                    <span><i class="fa fa-paperclip"></i></span>
                                </a>

                                <ul class="dropdown-menu" style="min-width:220px;">
                                    <li v-if="attachments_loading">
                                        <div class="row">
                                            <div class="col-sm-12 text-center">
                                                <div class="preloader"></div>
                                            </div>
                                        </div>
                                    </li>

                                    <li v-if="!attachments_loading && invoices.length > 0 && can_see_invoices">
                                        <a href="" @click.prevent="attachTo('invoice')"><i class="zmdi zmdi-file-text m-r-10"></i>{{ trans('client.attach_invoice') }}</a>
                                    </li>
                                    <li v-if="!attachments_loading && creditnotes.length > 0 && can_see_invoices">
                                        <a href="" @click.prevent="attachTo('creditnote')"><i class="zmdi zmdi-file-text m-r-10"></i>{{ trans('client.attach_creditnote') }}</a>
                                    </li>
                                    <li v-if="!attachments_loading && journals.length > 0 && is_journal_active">
                                        <a href="" @click.prevent="attachTo('journal-entry')"><i class="zmdi zmdi-assignment m-r-10"></i>{{ trans('client.attach_journal_entry') }}</a>
                                    </li>
                                    <li v-if="!attachments_loading && journal_files.length > 0 && is_journal_active">
                                        <a href="" @click.prevent="attachTo('journal-file')"><i class="zmdi zmdi-file m-r-10"></i>{{ trans('client.attach_journal_file') }}</a>
                                    </li>
                                    <li v-if="!attachments_loading">
                                        <a href="" @click.prevent="openUploadPrompt()"><i class="fa-solid fa-file-plus m-r-10"></i>{{ trans('client.attach_file') }}</a>
                                    </li>
                                </ul>
                            </div>

                            <div class="w-full">
                                <textarea-autosize :max-height="textAreaMaxHeight" :placeholder="trans('apps.messaging_type_your_message')" class="form-control" name="text" v-model="messageText" id="messageInputField" style="height: 28px;" required></textarea-autosize>
                                <p v-show="errors.has('text')" class="text-danger mb-0">{{ errors.first('text') }}</p>
                            </div>

                            <div id="messagesFileUpload">
                                <input type="file" name="file[]" v-for="attachedFile in attachedFiles" :id="'messagesFileUpload-' + attachedFile" multiple v-on:change="attachFile()">
                            </div>

                        </div>
                        <button class="btn btn-block " type="submit" :disabled="loading || isMessageSizeAboveLimit">
                            <i class="fa fa-send"></i><span class="m-l-10">{{ trans('messages.send') }}</span>
                        </button>
                    </form>
                </div>
            </div>

            <div id="attachment-modal"  class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;" v-if="can_edit_client">
                <div class="modal-dialog has-tabs">
                    <div class="panel panel-color panel-inverse m-0">
                        <div class="panel-heading">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                            <h3 class="panel-title truncate" >
                                <span v-if="attachment_mode === 'invoice'">{{ client.name }} - {{ trans('client.invoice') }}</span>
                                <span v-if="attachment_mode === 'creditnote'">{{ client.name }} - {{ trans('global.creditnote') }}</span>
                                <span v-if="attachment_mode === 'journal-entry'">{{ client.name }} - {{ trans('client.journal_entry') }}</span>
                                <span v-if="attachment_mode === 'journal-file'">{{ client.name }} - {{ trans('client.journal_file') }}</span>
                            </h3>
                        </div>
                    </div>
                    <div class="modal-content p-0">
                        <div class="modal-body modal-normal-bg">
                            <div class="row">
                                <div class="col-xs-12">
                                    <div v-if="attachment_mode === 'invoice' && can_see_invoices">
                                        <h4 class="m-t-0 m-b-15 text-muted"><i class="zmdi zmdi-attachment-alt m-r-10"></i>{{ trans('client.choose_attached_invoice') }}</h4>

                                        <div class="invoices-overview">
                                            <a href="" class="invoice-row relative" @click.prevent="selectInvoice(invoice)" v-for="invoice in invoices" :key="invoice.id">
                                                <div class="card-box bg-box hoverable relative">
                                                    <div :class="'marker ' + invoice.status"></div>
                                                    <div class="row">
                                                        <div class="col-xs-12 col-sm-2 truncate">
                                                            <span>{{ invoice.number }}</span>
                                                        </div>
                                                        <div class="col-xs-6 col-sm-6 truncate text-muted"> {{ getDateFormatted(invoice.date) }} </div>
                                                        <div class="col-xs-6 col-sm-4 truncate text-muted">{{ invoice.currency }} {{ formatAmount(invoice.paid_price) }}</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>

                                    <div v-if="attachment_mode === 'creditnote' && can_see_invoices">
                                        <h4 class="m-t-0 m-b-15 text-muted"><i class="zmdi zmdi-attachment-alt m-r-10"></i>{{ trans('client.choose_attached_invoice') }}</h4>

                                        <div class="invoices-overview">
                                            <a href="" class="invoice-row relative" @click.prevent="selectCreditnote(creditnote)" v-for="creditnote in creditnotes" :key="creditnote.id">
                                                <div class="card-box bg-box hoverable relative">
                                                    <div :class="'marker ' + creditnote.status"></div>
                                                    <div class="row">
                                                        <div class="col-xs-12 col-sm-2 truncate">
                                                            <span>{{ creditnote.number }}</span>
                                                        </div>
                                                        <div class="col-xs-6 col-sm-6 truncate text-muted"> {{ getDateFormatted(creditnote.date) }} </div>
                                                        <div class="col-xs-6 col-sm-4 truncate text-muted">{{ creditnote.currency }} {{ formatAmount(creditnote.paid_price) }}</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>

                                    <div v-if="attachment_mode === 'journal-entry'">
                                        <h4 class="m-t-0 m-b-15 text-muted"><i class="zmdi zmdi-attachment-alt m-r-10"></i>{{ trans('client.choose_attached_journal_entry') }} </h4>

                                        <div class="invoices-overview">
                                            <div v-for="journal in journals" :key="journal.id" class="relative">
                                                <a href="" class="invoice-row relative" @click.prevent="selectJournal(journal)">
                                                    <div class="card-box bg-box hoverable relative">
                                                        <div class="row">
                                                            <div class="col-xs-12 col-sm-12">
                                                                <div class="flex justify-between">
                                                                    <div class="truncate pr-7">
                                                                        <span>{{ getJournalDateFormatted(journal.date) }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-xs-12 col-sm-12 text-muted" v-sanitize-html="journal.excerpt"></div>
                                                        </div>
                                                    </div>
                                                </a>
                                                <span class="dropdown absolute right-0 top-0 pt-7 pr-7">
                                                <a href="#" class="dropdown-toggle n-color-text-weak hover:text-primary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span v-tooltip="trans('client.journal_print_entry')">
                                                        <i class="fas fa-print"></i>
                                                    </span>
                                                </a>
                                                <ul class="dropdown-menu dropdown-menu-right">
                                                    <li><a href="#" @click.prevent="selectJournal(journal)">{{ trans('client.portrait') }}</a></li>
                                                    <li><a href="#" @click.prevent="selectJournal(journal, 'landscape')">{{ trans('client.landscape') }}</a></li>
                                                </ul>
                                            </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="attachment_mode === 'journal-file'">
                                        <h4 class="m-t-0 m-b-15 text-muted"><i class="zmdi zmdi-attachment-alt m-r-10"></i> {{ trans('client.choose_attached_journal_file') }}</h4>

                                        <div class="invoices-overview">
                                            <a href="" class="invoice-row relative" @click.prevent="selectJournalFile(journal_file)" v-for="journal_file in journal_files">
                                                <div class="card-box bg-box hoverable relative">
                                                    <div class="row">

                                                        <div class="col-sm-2">
                                                            <div v-if="journal_file.type == 'image'">
                                                                <img :src="journal_file.thumb_url" alt="" style="max-width: 100%;">
                                                            </div>
                                                            <div v-else>
                                                                <i class="zmdi zmdi-file"></i>
                                                            </div>
                                                        </div>

                                                        <div class="col-xs-12 col-sm-7 truncate">
                                                            <span>{{ journal_file.display_name }}</span>
                                                        </div>

                                                        <div class="col-xs-12 col-sm-3 truncate text-muted text-right">
                                                            {{ getDateFormatted(journal_file.created_at) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </secure-authentication-gate>
</template>

<style>
.delete-link, .mark-as-unread {
    cursor: pointer;
}

.tooltip {
    min-width: 200px;
    z-index: 1000;
}
</style>
